import { get } from 'lodash'

export default (state) => get(state, ['auth', 'isAuthenticated'], false)
